<template>
  <div>
    <error-alert ref="errorAlert" />

    <b-alert
      :show="showSubscriptionSuccess"
      variant="success"
      fade
      dismissible
      @dissmiss="showSubscriptionSuccess = false"
    >
      <div class="alert-body">
        {{ $t('service-subscription.successfully-subscribed') }}
      </div>
    </b-alert>
    <b-row v-if="!subscription">
      <b-col cols="12">
        <getting-started
          :is-community-subscription="isCommunitySubscription"
          @error="onError"
        />
      </b-col>
    </b-row>
    <b-row v-if="subscription">
      <b-col cols="12">
        <!-- TODO: Remove update subscription? -->
        <subscription-infos
          ref="subscriptionInfos"
          :subscription="subscription"
          @subscription-refreshed="fetchSubscription"
          @subscription-suspended="onSubscriptionPaused"
          @subscription-reactivated="onSubscriptionReactivated"
          @reactivate-inactive-subscription="reactivateInactiveSubscription"
          @update-subscription="showUpdateSubscriptionModal"
          @subscription-cancelled="onSubscriptionCancelled"
          @error="onError"
        />
      </b-col>
    </b-row>
    <b-row
      v-if="subscription"
      class="mt-3"
    >
      <b-col cols="12">
        <transactions-history @error="onError" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BAlert } from 'bootstrap-vue'
import GettingStarted from './GettingStarted.vue'
import SubscriptionInfos from './SubscriptionInfos.vue'
import TransactionsHistory from './TransactionsHistory.vue'

export default {
  components: {
    BRow,
    BCol,
    BAlert,

    GettingStarted,
    SubscriptionInfos,
    TransactionsHistory,
  },
  data() {
    return {
      subscription: null,
      inactiveSubscription: null,
      showSubscriptionSuccess: false,
      isCommunitySubscription: false,
    }
  },
  mounted() {
    if (this.$store.state.selection.service.SubscriptionId) {
      this.fetchSubscription()
    }

    // Before the socket connects, the connect handler below joins instead
    if (this.$socket.client.connected) {
      this.joinSubscriptionRoom()
    }
  },
  beforeDestroy() {
    this.$socket.client.emit('leaveServiceSubscriptionRoom', this.$store.state.selection.service.id)
  },
  methods: {
    joinSubscriptionRoom() {
      this.$socket.client.emit('joinServiceSubscriptionRoom', this.$store.state.selection.service.id)
    },
    fetchSubscription(callback = null) {
      this.$store
        .dispatch('admin/FETCH_SUBSCRIPTION')
        .then(response => {
          this.subscription = response.data

          if (!this.$store.state.selection.service.SubscriptionId) {
            this.$store.dispatch('selection/SET_SERVICE_SUBSCRIPTION_ID', this.subscription.id)
          }
        })
        .catch(error => {
          if (error.response.data && error.response.data.code === 'E_COMMUNITY_SUBSCRIPTION') {
            this.subscription = null
            this.isCommunitySubscription = true
            return
          }

          this.onError(error)
        })
        .finally(() => {
          if (this.$refs.subscriptionInfos) {
            this.$refs.subscriptionInfos.stopRefreshSubscriptionLoading()
          }

          if (callback) {
            callback()
          }
        })
    },
    reactivateInactiveSubscription() {
      this.inactiveSubscription = this.subscription
      this.subscription = null
    },
    cancelReactivation() {
      this.subscription = this.inactiveSubscription
      this.inactiveSubscription = null
    },
    onError(error) {
      this.$refs.errorAlert.showError(error)
    },
    showUpdateSubscriptionModal() {
      this.$bvModal.show('update-subscription-modal')
    },
    onSubscriptionCreated() {
      this.$posthog.capture('subscription_created', {
        communityId: this.$store.getters['selection/currentCommunity'].id,
        communityName: this.$store.getters['selection/currentCommunity'].name,
        serviceId: this.$store.getters['selection/currentService'].id,
        serviceName: this.$store.getters['selection/currentService'].name,
        subscriptionId: this.subscription.id,
        subscriptionType: 'SERVICE',
      })
    },
    onSubscriptionPaused() {
      this.$posthog.capture('subscription_paused', {
        communityId: this.$store.getters['selection/currentCommunity'].id,
        communityName: this.$store.getters['selection/currentCommunity'].name,
        serviceId: this.$store.getters['selection/currentService'].id,
        serviceName: this.$store.getters['selection/currentService'].name,
        subscriptionId: this.subscription.id,
        subscriptionType: 'SERVICE',
      })

      this.fetchSubscription()
    },
    onSubscriptionCancelled() {
      this.$posthog.capture('subscription_cancelled', {
        communityId: this.$store.getters['selection/currentCommunity'].id,
        communityName: this.$store.getters['selection/currentCommunity'].name,
        serviceId: this.$store.getters['selection/currentService'].id,
        serviceName: this.$store.getters['selection/currentService'].name,
        subscriptionId: this.subscription.id,
        subscriptionType: 'SERVICE',
      })

      this.fetchSubscription()
    },
    onSubscriptionReactivated() {
      this.$posthog.capture('subscription_reactivated', {
        communityId: this.$store.getters['selection/currentCommunity'].id,
        communityName: this.$store.getters['selection/currentCommunity'].name,
        serviceId: this.$store.getters['selection/currentService'].id,
        serviceName: this.$store.getters['selection/currentService'].name,
        subscriptionId: this.subscription.id,
        subscriptionType: 'SERVICE',
      })

      this.fetchSubscription()
    },
  },
  sockets: {
    // The server forgets room membership when the socket drops, so join again
    // on every (re)connect or STATUS_CHANGED never arrives
    connect() {
      this.joinSubscriptionRoom()
    },
    STATUS_CHANGED(payload) {
      if (payload === 'ACTIVE') {
        // ACTIVE is also sent on renewals and plan updates, so only a page
        // that had no subscription yet counts as a new one
        const isNewSubscription = !this.subscription

        // The API emits after its writes land, so one fetch is enough
        this.fetchSubscription(() => {
          if (isNewSubscription && this.subscription) {
            this.onSubscriptionCreated()
            this.showSubscriptionSuccess = true
          }
        })
      }
    },
  },
}
</script>
